<template>
    <div>
        <div class="ownerHead flex-column flex-center p-4 border-box">
            <div
                :style="{
                    backgroundImage: `url('${$getImageUrl(userInfo.image) || require('@/assets/img/noAvatar.png')}')`,
                }"
                class="avatar flex-center"
            ></div>
            <div class="nickName mt-3">
                {{ userInfo.name }}
            </div>
        </div>

        <div class="orderArea">
            <div class="myOrder" @click="handleToOrder(0, '全部')">
                <div>我的订单</div>
                <div class="jc-between ai-center">
                    <div class="mr-1" style="font-size: 3.5vw;color: #a2a2a2;">查看全部</div>
                    <van-icon size="4vw" name="arrow" />
                </div>
            </div>
            <div class="orderItems ai-center jc-around">
                <div @click="handleToOrder(item.navIndex, item.title)" class="orderItem" v-for="(item, index) in orderType" :key="index">
                    <div class="itemIcon">
                        <icon-svg :color="$primary" :size="item.size" :name="item.icon" />
                    </div>
                    <div class="itemTitle">{{ item.title }}</div>
                </div>
            </div>
        </div>

        <!-- <van-cell @click="$router.push('/collection')" title="我的收藏" is-link /> -->
    </div>
</template>
<script>
import { msUserInfo } from "@/utils/variable";
export default {
    data() {
        return {
            orderType: [
                {
                    icon: "waitConfirm",
                    title: "待处理",
                    size: "8.5vw",
                    navIndex: 1,
                },
                {
                    icon: "ordering",
                    title: "处理中",
                    size: "8vw",
                    navIndex: 2,
                },
                {
                    icon:"menu_toTravel",
                    title: "待出行",
                    size: "7.8vw",
                    navIndex: 3
                },
                {
                    icon:"menu_afterSale",
                    title: "售后",
                    size: "8vw",
                    navIndex: 4
                },
                // {
                //     icon: "reserveSuccess",
                //     title: "预定成功",
                //     size: "8vw",
                //     navIndex: 3,
                // },
                // {
                //     icon: "reserveFail",
                //     title: "预定失败",
                //     size: "8vw",
                //     navIndex: 4,
                // },
                // {
                //     icon: "complete",
                //     title: "已完成",
                //     size: "8vw",
                //     navIndex: 7,
                // },
            ],
            userInfo: {},
        };
    },
    methods: {
        handleToOrder(index, title) {
            this.$router.push({ path: "/orderList", query: { index, title } });
        },
    },
    created() {
        this.userInfo = localStorage[msUserInfo] ? JSON.parse(localStorage[msUserInfo]) : {};
    },
};
</script>

<style lang="scss" scoped>
.ownerHead {
    height: 47.5vw;
    // background: linear-gradient(to right, #ff8484, #e44949);
    background: linear-gradient(to right, #ffdc9a, #ffc04b);
    box-shadow: 0 3px 3px rgba($color: #000000, $alpha: 0.3);
    position: relative;
    > div {
        z-index: 2;
    }
    &:before {
        position: absolute;
        content: "";
        z-index: 1;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: radial-gradient(rgba(0, 0, 0, 0.055), rgba(0, 0, 0, 0.1));
    }
    .avatar {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        border: 2px #fff solid;
        border-radius: 50%;
        width: 16vw;
        height: 16vw;
        flex-shrink: 0;
    }
    .nickName {
        color: #fff;
        font-weight: bold;
        font-size: 4.2vw;
    }
}
.orderArea {
    background-color: #fff;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    padding: 2.6vh 2.4vw;
    box-sizing: border-box;
    border-bottom: 0.8vh #f6f6f6 solid;
    .myOrder {
        height: 7vw;
        text-align: left;
        color: #000;
        font-size: 4.2vw;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-shrink: 0;
        padding: 0 1vw;
    }
    .orderItems {
        flex-shrink: 0;
        box-sizing: border-box;
        padding-top: 2vh;
        .orderItem {
            min-width: 12vw;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            flex-shrink: 0;
        }
        .itemIcon {
            width: 7.8vw;
            height: 7.8vw;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
            position: relative;
        }
        .itemTitle {
            margin-top: 1.8vh;
            color: #333;
            font-size: 3.7vw;
        }
    }
}
</style>
